import { computed } from 'vue'
import { useRoute } from 'vue-router'

const SITE_ORIGIN = 'https://hpvillage.com'

function buildItemsFromPath(path) {
  if (!path) return []

  const segments = path.split('/').filter(Boolean)
  const items = [
    { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_ORIGIN}/` }
  ]

  let current = `${SITE_ORIGIN}/`
  segments.forEach((segment, index) => {
    current += `${segment}/`
    items.push({
      '@type': 'ListItem',
      position: index + 2,
      name: decodeURIComponent(segment).replace(/-/g, ' ').toUpperCase(),
      item: current
    })
  })

  return items
}

export const useBreadcrumbSchema = () => {
  const route = useRoute()

  const headEntry = computed(() => {
    const itemListElement = buildItemsFromPath(route.path)
    if (itemListElement.length < 2) return {}

    return {
      script: [
        {
          key: 'breadcrumb-schema',
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement
          })
        }
      ]
    }
  })

  useHead(headEntry)
}
